export default "__VITE_ASSET__sLUPPbvp__"